//=require scripts/helpers.js
//=require scripts/config.js
//=require scripts/scripts.js
//=require scripts/contacts.js
//=require scripts/scroll-to-anchor.js
//=require scripts/header.js
//=require scripts/form-validate.js
//=require scripts/header-nav-link.js
//=require scripts/reviews-video.js
//=require scripts/service-prices-table.js
//=require scripts/custom-scroll.js
//=require scripts/blog.js
//=require scripts/authors-load-more.js
//=require scripts/author-skills.js
//=require scripts/footer.js
//=require scripts/banners.js
//=require scripts/form-kuzov.js
//=require scripts/init-gallery-slider.js
//=require scripts/init-reglament-slider.js
//=require scripts/faq-accordeon.js
//=require scripts/init-price-list.js
//=require scripts/init-horizontal-scrollbox.js
//=require scripts/cookie-notice.js

